import { ele } from "cables-shared-client";

export default class Shortcuts
{
    constructor()
    {
        const shortcutEles = document.querySelectorAll("[data-shortcut]");

        for (let i = 0; i < shortcutEles.length; i++)
        {
            const sEle = shortcutEles[i];
            document.body.addEventListener("keydown", (event) =>
            {
                if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) return;

                if (sEle.dataset.shortcut === "hide" && event.key === "Escape")
                {
                    ele.hide(sEle);
                    return;
                }

                if (!(sEle.dataset.shortcut === "finish" && event.key === "Enter" && (event.ctrlKey || event.metaKey)))
                {
                    if (document.activeElement.tagName === "TEXTAREA" || document.activeElement.tagName === "INPUT") return;
                    if (event.key !== sEle.dataset.shortcut) return;
                }

                if (sEle.getAttribute("onClick"))
                {
                    sEle.click();
                }
                else if (sEle.getAttribute("href"))
                {
                    document.location.href = sEle.getAttribute("href");
                }
            });
        }

        document.body.addEventListener("keydown", (e) =>
        {
            if (!(e.key === "Enter" && e.metaKey)) return;
            if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;

            let target = e.target;
            if (target.form) target.form.submit();
        });
    }
}

